import axios from "axios";
import { logoutUserOn401 } from "./authUtils/helper/auth";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`, // Laravel backend
  withCredentials: true, // Required for Sanctum session auth
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Accept": "application/json",
  },
});

api.interceptors.response.use(
  response => response,
  error => {
    const { config, response } = error;
    const url = config.url || '';

    // treat any of these as "auth" requests
    const isAuthRequest =
      url.endsWith('/login') ||
      url.endsWith('/register') ||
      url.endsWith('/sanctum/csrf-cookie');

    // only fire logout on non‐auth endpoints
    if (response?.status === 401 && !isAuthRequest) {
      logoutUserOn401();
    }
    if (response?.status === 403 && url.includes('/admin_dashboard') && !window.__redirecting) {
      // optional: send message event
      window.dispatchEvent(
        new CustomEvent("access-denied", {
          detail: { message: "You are not authorized to access admin panel." }
        })
      );
      // redirect
      window.__redirecting = true;
      window.location.href = "/dashboard";
    }
    if (!response) {
      let message = "Network error. Please check your connection.";

      if (error.code === "ECONNABORTED") {
        message = "Request timed out. Please try again.";
      }

      window.dispatchEvent(
        new CustomEvent("network-error", {
          detail: { message }
        })
      );
    }
    // always reject so your component's .catch() runs
    return Promise.reject(error);
  }
);

export default api;
